export default __webpack_public_path__ + "static/media/a7595081f7e98bc3ccc746fed846de5a1598728238950.1fbefda2.webp";